import gql from "graphql-tag"
import { SchoolFragmentDoc, ThemeFragmentDoc } from "@pathwright/graphql-client/src/generated"

export default gql`
  query SchoolQuery($id: Int!) {
    context(school_id: $id) {
      school {
        ...School
        theme {
          ...Theme
        }
      }
    }
  }
  ${SchoolFragmentDoc}
  ${ThemeFragmentDoc}
`
